/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { THue, THueVariationString, TSize } from 'volta/utils/style-utils';

import Component from '@glimmer/component';
import type { SafeString } from '@ember/template';

type TBadgeSize = Extract<TSize, 'sm' | 'md' | 'lg'>;

export interface BvBadgeArgs {
  color?: THueVariationString;
  size?: TBadgeSize;
  subtle?: boolean;
  splitColor?: THue;
  outline?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  tooltip?: string;
  text?: string | SafeString;
  tabindex?: `${number}`;
}

interface BvBadgeSignature {
  Args: BvBadgeArgs;
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const Sizes: Set<TBadgeSize> = new Set(['sm', 'md', 'lg']);

export default class BvBadgeComponent extends Component<BvBadgeSignature> {
  get colorClass() {
    const { color } = this.args;
    return color ? `bv-badge--${color}` : undefined;
  }

  get sizeClass() {
    const { size } = this.args;
    return size && Sizes.has(size) ? `bv-badge--${size}` : undefined;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvBadge: typeof BvBadgeComponent;
    'bv-badge': typeof BvBadgeComponent;
  }
}
